/*global t, rxu, translate*/
import React, { useEffect, useState } from 'react'
import { FixedSizeList,VariableSizeList } from 'react-window';

const { checkNameUser, checkName, checkAvatarSender, changeColorAva, textAva } = global.rootRequire('classes/chat')
const { timeConverter, rxChangeSlug, stringToColour, rxaget} = global.rootRequire('classes/ulti')
const { rxgetLocal } = global.rootRequire('classes/request')

const chatDB = global.rootRequire('classes/indexedDB').default

global.isclient && require('./index.css')
export default ({messages, users, ...props}) => {
    const [flagEmpty, setFlagEmpty] = useState(false)
    const [keywords, setKeywords] = useState("")
    const [total, setTotal] = useState(0)
    const [result, setResult] = useState([])
    const [groupId, setGroupId] = useState(props.group_id)
    const [selectItem, setSelectItem] = useState({})
    const [clickNext, setClickNext] = useState(false)
    const [clickPre, setClickPre] = useState(false)
    var refMess = {}

    useEffect(() => {
        const timeSearch = setTimeout(() => {
            if (keywords !== "") fetchDataSearch()
            else {
                reset()
            }
        }, 500);
      
        return () => clearTimeout(timeSearch);
    }, [keywords])

    const reset = () => {
        setTotal(0)
        setResult([])
        setKeywords("")
        setSelectItem({})
        setClickNext(false)
        setClickPre(false)
        props.onChange("")
    }

    useEffect(() => {
        if(props.group_id !== groupId) {
            setGroupId(props.group_id)
            reset()
            props.onCancel();
        }
    }, [props.group_id])


    useEffect(() => {
        // const ele = props.refScroll_chat[selectItem.message_id]
        // if(ele) {
        //     ele.scrollIntoView(false)
        //     ele.classList.add("hover-chat")
        //     setTimeout(() => {
        //         ele.classList.remove("hover-chat")
        //     }, 2000);
        // }
        let index = result.findIndex(o => o.message_id === selectItem.message_id)
        if(index > 0 && index < result.length) {
            setClickPre(true)
        } else if(index === 0) {
            setClickPre(false)
        }
        if(index >= 0 && index < result.length - 1) {
            setClickNext(true)
        } else if(index === result.length - 1) {
            setClickNext(false)
        }
    }, [selectItem])

    const fetchDataSearch = () => {
        var total = 0
        var result = []
        setSelectItem({})
        setClickNext(false)
        setClickPre(false)

        searchKeywords(keywords)
        
        props.onChange(keywords)
        if(total > 1) {
            setClickPre(true)
        }
    }

    const searchKeywords = async (keyword) => {  
        const api_search_keyword = global.rxu.config.api_search_keyword         
        let group_id = rxaget(props, 'group_id', 0)
        let user_id = rxaget(props, 'user.id', 0)
        let token = rxaget(props, 'user.token', '')
        
        let requestHeader = `?keyword=${keywords}&group_id=${group_id}&page=0&size=50`

        const res = await fetch(api_search_keyword + requestHeader, { 
            method: 'GET',
            headers: { Accept: 'application/json', 'TC-Token': token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }, 
            body: null
        })
          
        try {
            let json = await res.json()
            if (json && json.messages && json.messages.constructor === Array && json.messages.length > 0 ) {
                let arrMess = json.messages
                let total = arrMess.length
                let result = arrMess.sort((a, b) => a.created_at < b.created_at ? 1 : (a.created_at > b.created_at ? -1 : 0))

                setTotal(total)
                setResult(result)
            } else {
                setFlagEmpty(true)
                setTotal(0)
                setResult([])
            }
        } catch (e) {
            console.log(e)
        }
    }

    const convertOmessUser = (omess) => {
        try {
            if (omess && omess.sender_uin && users && users[omess.sender_uin]) {
                let user = users[omess.sender_uin] || {}
                return user
            } else {
                return {}
            }
        } catch(e) {
            return {}
        }
    }

    const onClickPreMessage = () => {
        if(clickPre) {
            if(selectItem.message_id) {
                let index = result.findIndex(o => o.message_id === selectItem.message_id)
                setSelectItem(result[index - 1])
            } else {
                setSelectItem(result[result.length - 1])
            }
        }
    }

    const onClickNextMessage = () => {
        if(clickNext) {
            let index = result.findIndex(o => o.message_id === selectItem.message_id)
            if(index !== -1 && index < result.length - 1) {
                setSelectItem(result[index + 1])
            }
        }
    }

    const RowMessage = ({ index, style }) => {
      let item = result[index]
      let message = ''
      if (item && item.message) {
        if (keywords.length > 2) {
            message = item.message.replaceAll(new RegExp(keywords.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "ig"), '<span class="zhighlight-chat">$&</span>')
        } else {
            message = item.message
        }
         
        if (message.indexOf('@') !== -1) {
            try {
                let userstag = message.match(/(@\d+\b)/ig)
                if (userstag && userstag.constructor === Array && userstag.length > 0) {
                    userstag.forEach(o => {
                        let useridtmp = o.replace('@', '') || ''
                        if (users && users[useridtmp]) {              
                            let userName = (users[useridtmp]['full_name']) ? users[useridtmp]['full_name'] : (users[useridtmp]['phone']) ? (users[useridtmp]['phone']) : translate('Stranger')
                            message = message.replace(o, `<b>${userName}</b>`)
                        }
                    })
                }
                message = message.replace(/\@All/g,'<b >@All</b>');
            } catch(e) {}
        }
        if (message.indexOf('[') !== -1) {
            message = message.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<span class="bbcode-bold">$1</span>')
            message = message.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
            message = message.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
        }
    }
      // ref={ele => refMess[item.message_id] = ele}
      // onClick={() => setSelectItem(item)}
      
      return <div style={style} key={index}>
          {(item && item.message_id) && <div  
            className={'zresult-item' + (selectItem?.message_id === item.message_id ? " zresult-active" : "")} 
            onClick={() => props.onClickToMess(item.message_id)}
            // ref={ele => refMess[item.message_id] = ele}
        >
            <div className='zresult-left'>
                <div className='zmessage_avasender' style={{ background: `${changeColorAva(rxaget(item, 'sender_uin', ''))}` }} >
                    { checkAvatarSender(item, users) && <img src={rxu.config.cdn_endpoint + users[item.sender_uin.toString()].profile_url} alt=''
                        data-id={'sender' + item.sender_uin}
                        className={'ava-sender images-static'}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = './images/default/static/avadefault.svg' 
                        }} />
                    }
                    <span className='avatar-sender'>
                        {textAva(rxChangeSlug(checkNameUser(convertOmessUser(item))))}
                    </span>
                </div>
            </div>
            <div className='zresult-right'>
                <div className='zresult-text'>
                    <div className='zresult-name'>{(convertOmessUser(item)) ? checkNameUser(convertOmessUser(item)) : (item && item.sender_name) ? item.sender_name.toString() : ''}</div>
                    <div className='zresult-message'><div dangerouslySetInnerHTML={{ __html: message }} /></div>
                </div>
                <div className='zresult-time'>{timeConverter(item.created_at, 'date')}</div>
            </div>
        </div>}
      </div>

      
    }

    return (
        <div className='zchat-search ztbar'>
            <div className='zsearch-body'>
                {/*<div className='zsearch-left'>
                    <span className={'icon-arrow-up zsearch-icon' + (clickPre ? " icon-active" : "")} onClick={() => onClickPreMessage()} />
                    <span className={'icon-arrow-down zsearch-icon' + (clickNext ? " icon-active" : "")} onClick={() => onClickNextMessage()} />
                </div>*/}
                <div className='zearch-input'>
                    <input value={keywords} autoFocus onChange={e => {if (flagEmpty) {setFlagEmpty(false)}; setKeywords(e.target.value)} } placeholder={t('Search')} />
                    <span className='icon-magnifier' />
                </div>
                <div className='zsearch-right'>
                    <span className='icon-close' onClick={() => {props.onCancel(); reset()}} />
                </div>
            </div>
            
            {total > 0 && <div className='zsearch-result'>
                <FixedSizeList
                    className='zresult-box'
                    height={(total > 4) ? 200 : (total*50)}
                    itemCount={total}
                    itemSize={50}
                >
                    {RowMessage}
                </FixedSizeList>
            </div>}
            {flagEmpty && <div className='zsearch-result-empty'>
                {translate('No matches found')}
            </div>}
        </div>
    )
}